import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { EMAIL_INVALID_MESSAGE } from 'common/components/form_fields';
import isEmail from 'sane-email-validation';
import InviteModal from 'project/components/collaborator_modal';
import {
  toggleCollaboratorModal, inviteCollaborator
} from 'project/ducks/collaborators';

export const COLLABORATOR_FORM = 'INVITE_COLLABORATOR_FORM';

export function validate(values) {
  const errors = {};
  if (!values.messages) {
    errors.messages = 'Please enter an invitation message';
  }

  if (!values.email || !isEmail(values.email)) {
    errors.email = EMAIL_INVALID_MESSAGE;
  }

  return errors;
}

export function mapStateToProps({ project: { collaborators } }) {
  const { showModal } = collaborators.data;
  return {
    showModal
  };
}

export function mapDispatchToProps(dispatch, { projectId }) {
  return bindActionCreators({
    toggle: toggleCollaboratorModal,
    onSubmit: partial(inviteCollaborator, projectId),
  }, dispatch);
}

const InviteForm = reduxForm({
  form: COLLABORATOR_FORM,
  validate,
})(InviteModal);

export default connect(mapStateToProps, mapDispatchToProps)(InviteForm);



// WEBPACK FOOTER //
// ./project/containers/collaborator_modal.js